import * as actionTypes from './actionTypes';

const initialState = {
  quarterlyPaymentObj: {},
  quarterlyPaymentDetailObj: {},
  planType: [],
  quarter: '',
  // rebateProgram: [],
  manufacturerList: [],
  mfgIds: [],
  searchResult: [],
  thresValue: '',
  displayData: {
    manufacturerId: '',
    manufacturerName: '',
    rebateProgram: '',
    balanceDueThreshold: true,
    totalPaid: '',
    quarterOption: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MANUFACTURERS_DATA_LIST:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };
    case actionTypes.GET_QUARTERLY_PAYMENT_DATA:
      return {
        ...state,
        searchResult: action.payload,
      };
    case actionTypes.GET_CURRENT_QUARTERLY_PAY_DISPLAY_OBJ:
      return { ...state, quarterlyPaymentObj: action.screenData };
    case actionTypes.GET_CURRENT_QUARTERLY_PAY_DETAIL_OBJ:
      return { ...state, quarterlyPaymentDetailObj: action.detailScrData };
    case actionTypes.GET_ERROR_MSG_QUARTERLY_PAYMENT:
      return { ...state, errorMsgQtrlyPayment: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return { ...state, dramsInvoice: action.payload };
    case actionTypes.GET_EARLIEST_QTR_DRUG_VALUE:
      return { ...state, earliestQtr: action.payload };
    case actionTypes.DISPLAY_QUARTER_RANGE:
      return { ...state, quarterOption: action.payload };
    case actionTypes.DISPLAY_QUARTER_OBJ:
      return { ...state, quarterRangeObj: action.payload };
    case actionTypes.GET_BALANCE_THRESHOLD_VALUE:
      return { ...state, thresValue: action.payload };
    case actionTypes.DISPLAY_QUARTERLY_PAYMENT_DETAILS:
      return { ...state, displayData: action.payload };
    case actionTypes.CLEAR_QTRLY_PAY_TAB:
      return [];

    default:
      return state;
  }
};
export default reducer;
